// extracted by mini-css-extract-plugin
export default {"table-cell":"table-cell--gb8fr"};